const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='bg-gray-900 text-white py-12'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='grid md:grid-cols-4 gap-8 mb-8'>
          {/* Brand */}
          <div className='col-span-2 md:col-span-1'>
            <div className='flex items-center space-x-2 mb-4'>
              <div className='w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center'>
                <svg
                  className='w-6 h-6 text-white'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z'
                  />
                </svg>
              </div>
              <span className='text-xl font-bold'>ScanKartu</span>
            </div>
            <p className='text-gray-400 text-sm'>
              Solusi kartu PVC/Digital modern dengan aplikasi gratis selamanya untuk kebutuhan
              bisnis dan pendidikan Anda.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className='font-semibold mb-4'>Produk</h4>
            <ul className='space-y-2 text-gray-400'>
              <li>
                <a href='#products' className='hover:text-white transition-colors'>
                  Kartu Pelajar
                </a>
              </li>
              <li>
                <a href='#products' className='hover:text-white transition-colors'>
                  Kartu Member
                </a>
              </li>
              <li>
                <a href='#products' className='hover:text-white transition-colors'>
                  Kartu Nama
                </a>
              </li>
            </ul>
          </div>

          {/* Features */}
          <div>
            <h4 className='font-semibold mb-4'>Fitur</h4>
            <ul className='space-y-2 text-gray-400'>
              <li>
                <a href='#features' className='hover:text-white transition-colors'>
                  Free Aplikasi
                </a>
              </li>
              <li>
                <a href='#features' className='hover:text-white transition-colors'>
                  Scan & Go
                </a>
              </li>
              <li>
                <a href='#features' className='hover:text-white transition-colors'>
                  Dashboard
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className='font-semibold mb-4'>Kontak</h4>
            <ul className='space-y-2 text-gray-400'>
              <li className='flex items-center space-x-2'>
                <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z' />
                </svg>
                <a
                  href='https://wa.me/6285235662062'
                  className='hover:text-white transition-colors'
                >
                  0852-3566-2062
                </a>
              </li>
              <li>
                <a
                  href='https://wa.me/6285235662062'
                  className='hover:text-white transition-colors'
                >
                  Chat WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className='pt-8 border-t border-gray-800'>
          <div className='flex flex-col md:flex-row justify-between items-center gap-4'>
            <p className='text-gray-400 text-sm'>© {currentYear} ScanKartu. All rights reserved.</p>
            <div className='flex items-center space-x-6 text-sm text-gray-400'>
              <a href='#' className='hover:text-white transition-colors'>
                Privacy Policy
              </a>
              <a href='#' className='hover:text-white transition-colors'>
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
